export const quartileColors = [
  'rgba(255,255,0, .2)',
  'rgba(0,128,0, .2)',
  'rgba(0,0,255, .2)',
  'rgba(255,165,0, .2)',
];
